import { useEffect } from 'react';

/**
 * Observes all .vis elements on the page and adds .show when they
 * enter the viewport. Call this once at the App level (or per page).
 */
export default function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    // Small delay so newly mounted elements are in the DOM
    const tid = setTimeout(() => {
      document.querySelectorAll('.vis').forEach((el) => observer.observe(el));
    }, 50);

    return () => {
      clearTimeout(tid);
      observer.disconnect();
    };
  });
}
